/* two-row-layout.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./two-row-layout.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { DynamicLayoutComponent } from '../../component/dynamic-layout-component';
var styles = {
  rowStyle: "_1bsb1osq"
};
var REQUIRED_ELEMENTS_COUNT = 1;
export var TwoRowLayout = function TwoRowLayout(_ref) {
  var elements = _ref.elements,
    key = _ref.key;
  if (elements.length < REQUIRED_ELEMENTS_COUNT) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Stack, {
    xcss: styles.rowStyle,
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.rowStyle
  }, /*#__PURE__*/React.createElement(DynamicLayoutComponent, {
    component: elements[0],
    position: "two-rows-bottom",
    key: "".concat(key, "-bottom")
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.rowStyle
  }, /*#__PURE__*/React.createElement(DynamicLayoutComponent, {
    component: elements[1],
    position: "two-rows-bottom",
    key: "".concat(key, "-bottom")
  })));
};